import { render } from "./NewLockScreen.vue?vue&type=template&id=d65cd1e6&scoped=true"
import script from "./NewLockScreen.vue?vue&type=script&lang=js"
export * from "./NewLockScreen.vue?vue&type=script&lang=js"

import "./NewLockScreen.vue?vue&type=style&index=0&id=d65cd1e6&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65cd1e6"]])

export default __exports__